import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ISubmitGrammarCheckpointV1Request } from './submit-grammar-checkpoint-v1-request';
import type { ISubmitGrammarCheckpointV1Response } from './submit-grammar-checkpoint-v1-response';
import { submitGrammarCheckpointV1ResponseSchema } from './submit-grammar-checkpoint-v1-response';

export async function submitGrammarCheckpointV1Api(
  body: ISubmitGrammarCheckpointV1Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<ISubmitGrammarCheckpointV1Response>> {
  return postRequest<ISubmitGrammarCheckpointV1Response>({
    path: '/grammar/checkpoint/submit/v1',
    body,
    schema: submitGrammarCheckpointV1ResponseSchema,
    options,
  });
}
